import { PriceType } from "../test-payloads/graphql";
import { getCanadianPrices } from "./get-canadian-prices";

type PriceTypeParameter = PriceType | string | undefined | null;

export interface IScenarioAction {
	priceType?: PriceType | null;
	adHocPriceTypes?: Array<PriceType> | null;
}

export const isFixedPrice = (priceType: PriceTypeParameter): boolean => {
	return (
		priceType === PriceType.PublicPrice ||
		priceType === PriceType.ExFactoryPrice ||
		priceType === PriceType.CustomPrice ||
		priceType === PriceType.NetPrice ||
		priceType === PriceType.ScenarioZeroNetPrice ||
		priceType === PriceType.ScenarioZeroMainNetPrice ||
		priceType === PriceType.ScenarioZeroRelevantNetPrice ||
		priceType === PriceType.AlbertaListPrice ||
		priceType === PriceType.BritishColumbiaListPrice ||
		priceType === PriceType.ManitobaListPrice ||
		priceType === PriceType.NewBrunswickListPrice ||
		priceType === PriceType.NewfoundlandAndLabradorListPrice ||
		priceType === PriceType.NorthwestTerritoriesListPrice ||
		priceType === PriceType.NovaScotiaListPrice ||
		priceType === PriceType.NunavutListPrice ||
		priceType === PriceType.OntarioListPrice ||
		priceType === PriceType.PrinceEdwardIslandListPrice ||
		priceType === PriceType.QuebecListPrice ||
		priceType === PriceType.SaskatchewanListPrice ||
		priceType === PriceType.YukonListPrice ||
		priceType === PriceType.AlbertaMarkedUpPrice ||
		priceType === PriceType.BritishColumbiaMarkedUpPrice ||
		priceType === PriceType.ManitobaMarkedUpPrice ||
		priceType === PriceType.NewBrunswickMarkedUpPrice ||
		priceType === PriceType.NewfoundlandAndLabradorMarkedUpPrice ||
		priceType === PriceType.NorthwestTerritoriesMarkedUpPrice ||
		priceType === PriceType.NovaScotiaMarkedUpPrice ||
		priceType === PriceType.NunavutMarkedUpPrice ||
		priceType === PriceType.OntarioMarkedUpPrice ||
		priceType === PriceType.PrinceEdwardIslandMarkedUpPrice ||
		priceType === PriceType.QuebecMarkedUpPrice ||
		priceType === PriceType.SaskatchewanMarkedUpPrice ||
		priceType === PriceType.YukonMarkedUpPrice ||
		priceType === PriceType.NihbListPrice ||
		priceType === PriceType.NihbMarkedUpPrice ||
		priceType === PriceType.VacListPrice ||
		priceType === PriceType.VacMarkedUpPrice
	);
};

export const isNetPriceType = (priceType: PriceTypeParameter): boolean => {
	return priceType === PriceType.NetPrice || priceType === PriceType.NetPricePercent;
};

export const isScenarioZeroNetPriceType = (priceType: PriceTypeParameter): boolean => {
	return priceType === PriceType.ScenarioZeroNetPrice || priceType === PriceType.ScenarioZeroNetPricePercent;
};

export const isScenarioZeroMainNetPriceType = (priceType: PriceTypeParameter): boolean => {
	return priceType === PriceType.ScenarioZeroMainNetPrice || priceType === PriceType.ScenarioZeroMainNetPricePercent;
};

export const isScenarioZeroRelevantNetPriceType = (priceType: PriceTypeParameter): boolean => {
	return priceType === PriceType.ScenarioZeroRelevantNetPrice || priceType === PriceType.ScenarioZeroRelevantNetPricePercent;
};

export const isScenarioZeroPriceType = (priceType: PriceTypeParameter): boolean => {
	return (
		isScenarioZeroNetPriceType(priceType) || isScenarioZeroRelevantNetPriceType(priceType) || isScenarioZeroMainNetPriceType(priceType)
	);
};

const canadianPriceSet = new Set(getCanadianPrices());

export const isCanadianPriceType = (priceType: PriceTypeParameter): boolean => {
	return canadianPriceSet.has(priceType);
};

export const isArt71RelatedPrice = (priceType: PriceType) =>
	priceType === PriceType.AvgGenericPercent ||
	priceType === PriceType.CrossCountryPercent ||
	priceType === PriceType.DiffBetweenExFactoryAndCrossCountry;

export const isNonFixedPrice = (priceType: PriceType) =>
	priceType === PriceType.PublicPricePercent ||
	priceType === PriceType.ExFactoryPricePercent ||
	priceType === PriceType.CustomPricePercent ||
	priceType === PriceType.DiffBetweenExFactoryAndCrossCountry ||
	priceType === PriceType.AlbertaListPricePercent ||
	priceType === PriceType.BritishColumbiaListPricePercent ||
	priceType === PriceType.ManitobaListPricePercent ||
	priceType === PriceType.NewBrunswickListPricePercent ||
	priceType === PriceType.NewfoundlandAndLabradorListPricePercent ||
	priceType === PriceType.NorthwestTerritoriesListPricePercent ||
	priceType === PriceType.NovaScotiaListPricePercent ||
	priceType === PriceType.NunavutListPricePercent ||
	priceType === PriceType.OntarioListPricePercent ||
	priceType === PriceType.PrinceEdwardIslandListPricePercent ||
	priceType === PriceType.QuebecListPricePercent ||
	priceType === PriceType.SaskatchewanListPricePercent ||
	priceType === PriceType.YukonListPricePercent ||
	priceType === PriceType.AlbertaMarkedUpPricePercent ||
	priceType === PriceType.BritishColumbiaMarkedUpPricePercent ||
	priceType === PriceType.ManitobaMarkedUpPricePercent ||
	priceType === PriceType.NewBrunswickMarkedUpPricePercent ||
	priceType === PriceType.NewfoundlandAndLabradorMarkedUpPricePercent ||
	priceType === PriceType.NorthwestTerritoriesMarkedUpPricePercent ||
	priceType === PriceType.NovaScotiaMarkedUpPricePercent ||
	priceType === PriceType.NunavutMarkedUpPricePercent ||
	priceType === PriceType.OntarioMarkedUpPricePercent ||
	priceType === PriceType.PrinceEdwardIslandMarkedUpPricePercent ||
	priceType === PriceType.QuebecMarkedUpPricePercent ||
	priceType === PriceType.SaskatchewanMarkedUpPricePercent ||
	priceType === PriceType.YukonMarkedUpPricePercent ||
	priceType === PriceType.NihbListPricePercent ||
	priceType === PriceType.NihbMarkedUpPricePercent ||
	priceType === PriceType.VacListPricePercent ||
	priceType === PriceType.VacMarkedUpPricePercent;

export const getPriceType = (actionsByTreatment: Array<IScenarioAction>): PriceType => {
	if (!actionsByTreatment.length) {
		return PriceType.PublicPricePercent;
	}

	const findPriceType = (isPriceTypeCheck: (priceType: PriceType) => boolean) => {
		for (const action of actionsByTreatment) {
			const adHocPriceTypes = Array.isArray(action?.adHocPriceTypes) ? action?.adHocPriceTypes : [action?.adHocPriceTypes];
			const potentialPriceType = [action.priceType, ...(adHocPriceTypes ?? [])]
				.filter(Boolean)
				.find((priceType) => isPriceTypeCheck(priceType!));
			if (potentialPriceType) {
				return potentialPriceType;
			}
		}

		return;
	};

	const nonFixedPriceType = findPriceType(isNonFixedPrice);
	if (nonFixedPriceType) {
		return nonFixedPriceType === PriceType.DiffBetweenExFactoryAndCrossCountry ? PriceType.ExFactoryPricePercent : nonFixedPriceType;
	}

	const art71RelatedPriceType = findPriceType(isArt71RelatedPrice);
	if (art71RelatedPriceType) {
		return art71RelatedPriceType === PriceType.DiffBetweenExFactoryAndCrossCountry
			? PriceType.ExFactoryPricePercent
			: art71RelatedPriceType;
	}

	const fixedPriceType = findPriceType(isFixedPrice);

	return mapPriceType(fixedPriceType);
};

export const mapPriceType = (priceType?: PriceType | null): PriceType => {
	switch (priceType) {
		case PriceType.ExFactoryPrice:
		case PriceType.ExFactoryPricePercent:
			return PriceType.ExFactoryPricePercent;
		case PriceType.PublicPrice:
		case PriceType.PublicPricePercent:
			return PriceType.PublicPricePercent;
		case PriceType.CustomPrice:
		case PriceType.CustomPricePercent:
			return PriceType.CustomPricePercent;
		case PriceType.AlbertaListPrice:
		case PriceType.AlbertaListPricePercent:
			return PriceType.AlbertaListPricePercent;
		case PriceType.BritishColumbiaListPrice:
		case PriceType.BritishColumbiaListPricePercent:
			return PriceType.BritishColumbiaListPricePercent;
		case PriceType.ManitobaListPrice:
		case PriceType.ManitobaListPricePercent:
			return PriceType.ManitobaListPricePercent;
		case PriceType.NewBrunswickListPrice:
		case PriceType.NewBrunswickListPricePercent:
			return PriceType.NewBrunswickListPricePercent;
		case PriceType.NewfoundlandAndLabradorListPrice:
		case PriceType.NewfoundlandAndLabradorListPricePercent:
			return PriceType.NewfoundlandAndLabradorListPricePercent;
		case PriceType.NorthwestTerritoriesListPrice:
		case PriceType.NorthwestTerritoriesListPricePercent:
			return PriceType.NorthwestTerritoriesListPricePercent;
		case PriceType.NovaScotiaListPrice:
		case PriceType.NovaScotiaListPricePercent:
			return PriceType.NovaScotiaListPricePercent;
		case PriceType.NunavutListPrice:
		case PriceType.NunavutListPricePercent:
			return PriceType.NunavutListPricePercent;
		case PriceType.OntarioListPrice:
		case PriceType.OntarioListPricePercent:
			return PriceType.OntarioListPricePercent;
		case PriceType.PrinceEdwardIslandListPrice:
		case PriceType.PrinceEdwardIslandListPricePercent:
			return PriceType.PrinceEdwardIslandListPricePercent;
		case PriceType.QuebecListPrice:
		case PriceType.QuebecListPricePercent:
			return PriceType.QuebecListPricePercent;
		case PriceType.SaskatchewanListPrice:
		case PriceType.SaskatchewanListPricePercent:
			return PriceType.SaskatchewanListPricePercent;
		case PriceType.YukonListPrice:
		case PriceType.YukonListPricePercent:
			return PriceType.YukonListPricePercent;
		case PriceType.AlbertaMarkedUpPrice:
		case PriceType.AlbertaMarkedUpPricePercent:
			return PriceType.AlbertaMarkedUpPricePercent;
		case PriceType.BritishColumbiaMarkedUpPrice:
		case PriceType.BritishColumbiaMarkedUpPricePercent:
			return PriceType.BritishColumbiaMarkedUpPricePercent;
		case PriceType.ManitobaMarkedUpPrice:
		case PriceType.ManitobaMarkedUpPricePercent:
			return PriceType.ManitobaMarkedUpPricePercent;
		case PriceType.NewBrunswickMarkedUpPrice:
		case PriceType.NewBrunswickMarkedUpPricePercent:
			return PriceType.NewBrunswickMarkedUpPricePercent;
		case PriceType.NewfoundlandAndLabradorMarkedUpPrice:
		case PriceType.NewfoundlandAndLabradorMarkedUpPricePercent:
			return PriceType.NewfoundlandAndLabradorMarkedUpPricePercent;
		case PriceType.NorthwestTerritoriesMarkedUpPrice:
		case PriceType.NorthwestTerritoriesMarkedUpPricePercent:
			return PriceType.NorthwestTerritoriesMarkedUpPricePercent;
		case PriceType.NovaScotiaMarkedUpPrice:
		case PriceType.NovaScotiaMarkedUpPricePercent:
			return PriceType.NovaScotiaMarkedUpPricePercent;
		case PriceType.NunavutMarkedUpPrice:
		case PriceType.NunavutMarkedUpPricePercent:
			return PriceType.NunavutMarkedUpPricePercent;
		case PriceType.OntarioMarkedUpPrice:
		case PriceType.OntarioMarkedUpPricePercent:
			return PriceType.OntarioMarkedUpPricePercent;
		case PriceType.PrinceEdwardIslandMarkedUpPrice:
		case PriceType.PrinceEdwardIslandMarkedUpPricePercent:
			return PriceType.PrinceEdwardIslandMarkedUpPricePercent;
		case PriceType.QuebecMarkedUpPrice:
		case PriceType.QuebecMarkedUpPricePercent:
			return PriceType.QuebecMarkedUpPricePercent;
		case PriceType.SaskatchewanMarkedUpPrice:
		case PriceType.SaskatchewanMarkedUpPricePercent:
			return PriceType.SaskatchewanMarkedUpPricePercent;
		case PriceType.YukonMarkedUpPrice:
		case PriceType.YukonMarkedUpPricePercent:
			return PriceType.YukonMarkedUpPricePercent;
		case PriceType.NihbListPrice:
		case PriceType.NihbListPricePercent:
			return PriceType.NihbListPricePercent;
		case PriceType.NihbMarkedUpPrice:
		case PriceType.NihbMarkedUpPricePercent:
			return PriceType.NihbMarkedUpPricePercent;
		case PriceType.VacMarkedUpPrice:
		case PriceType.VacMarkedUpPricePercent:
			return PriceType.VacMarkedUpPricePercent;
		default:
			return PriceType.PublicPricePercent;
	}
};
